import axiosInstance from "../axiosInstance";

const BASE_URL = "/crm/dashboard";

export const getCrmDashboard = async (params = {}) => {
  const response = await axiosInstance.get(BASE_URL, {
    params,
    withCredentials: true,
  });
  return response.data;
};
